import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';
@Injectable({
	providedIn: 'root',
	deps: [L10nTranslationService, HttpClient],
})
export class CommonServices {
	/**
	 * Constructor
	 * @param ts Translation service
	 * @param http Http client
	 */
	constructor(public ts: L10nTranslationService, public http: HttpClient) {}
}
